import { render } from "./TestDrive.vue?vue&type=template&id=4310934d&ts=true"
import script from "./TestDrive.vue?vue&type=script&lang=ts"
export * from "./TestDrive.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__